 import React, { useState, useEffect } from 'react'
 import axios from 'axios';

const CompensationBeneficiaryUpdate = ({ beneficiaryDetails, totalCompensationAmount, onUpdate }) => {
  debugger
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    debugger
    // Initialize beneficiaries with calculated compensation shares
    const updatedDetails = beneficiaryDetails.map((beneficiary) => ({
      ...beneficiary,
      CompensationAmount:
        ((beneficiary.LandShare *totalCompensationAmount) /100).toFixed(2), // Calculate share
    }));
    setBeneficiaries(updatedDetails);
  }, [beneficiaryDetails, totalCompensationAmount]);
  

  const handleChange = (index, field, value) => {
    debugger
    const updatedDetails = [...beneficiaryDetails];
    updatedDetails[index][field] = value;
    onUpdate(updatedDetails); // Notify parent component

    if (field === "LandShare") {
      // Recalculate CompensationAmount based on LandShare
      updatedDetails[index].CompensationAmount =
        (value/100) * totalCompensationAmount;
    }

  };

  const handleSave = async () => {
    debugger
    setLoading(true);
    setError(null);

    try {
      debugger
      // Call the API to update the compensation details
      const response = await axios.put('https://backurrda.sarmar.co.in/api/BeneficiaryUpdate/update', 
      {
        beneficiaries: beneficiaryDetails, // Send the updated beneficiary data
      });

      if (response.status === 200) {
        alert('Compensation updated successfully!');
        setLoading(false);
      }
    } catch (error) {
      setError('Failed to update compensation.');
      setLoading(false);
    }
  };
  
  return (

        <div className="flex-1 px-6 py-4 overflow-auto">
          <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
            <h1>Compensation Share B/w Beneficiary</h1>

          </div>
            <h2 className="text-[#241C68] underline mb-4"> &#x25CF; Consent</h2>
            <span className='text-red-600'>Please Upload Common Consent Letter in Order to change Compensation Share</span>
            <section className="mt-6">
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <label htmlFor="">Common Consent

              <input
                className="rounded-md p-2 w-full outline-dashed outline-2 outline-offset-3 bg-[#F2F2F2]"
                placeholder="Common Consent"
                type="file"
                />
                </label>
            </div> */}
            <div class="items-center justify-center grid grid-cols-4">
          <label
            for="dropzone-file"
            class="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-200"
          >
            <div class="flex items-center justify-end pt-5 pb-6">
            <p class="text-xs text-gray-500 dark:text-gray-400 mr-2">
            📄 Common Consent
              </p>
              <svg
                class="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>
              {/* <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Click to upload</span> or drag and drop</p> */}
              
            </div>
            <input id="dropzone-file" type="file" class="hidden" />
          </label>
        </div>
          </section>
          <section className="mt-10">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2">Beneficiary</th>
                  <th className="border border-gray-300 p-2">Land Share %</th>
                  <th className="border border-gray-300 p-2">Compensation Amount</th>
                </tr>
              </thead>
              {/* <tbody>
                <tr>
                  <td className="border border-gray-300 p-2"><input className="w-full" type="text" /></td>
                  <td className="border border-gray-300 p-2"><input className="w-full" type="text" /></td>
                  <td className="border border-gray-300 p-2"><input className="w-full" type="text" /></td>
                </tr>
              </tbody> */}
              <tbody>
        {beneficiaryDetails.map((beneficiary, index) => (
          <tr key={beneficiary.BeneficiaryId}>
            <td className="border border-gray-300 p-2">
              <input
                className="w-full"
                type="text"
                value={beneficiary.Name || ""}
                readOnly
                onChange={(e) =>
                  handleChange(index, "Name", e.target.value)
                }
              />
            </td>
            <td className="border border-gray-300 p-2">
              <input
                className="w-full"
                type="text"
                value={beneficiary.LandShare || ""}
                onChange={(e) =>
                  handleChange(index, "LandShare", e.target.value)
                }
              />
            </td>
            <td className="border border-gray-300 p-2">
              <input
                className="w-full"
                type="text" 
                readOnly
                value={beneficiary.CompensationAmount || ""}
                onChange={(e) =>
                  handleChange(index, "CompensationAmount", e.target.value)
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
            </table>
          </section>
          <button 
          className='border bg-[#241C68] text-white w-full mt-3.5'
          onClick={handleSave}
          >Save</button>
        </div>
    
  )
}

export default CompensationBeneficiaryUpdate


// import React, { useEffect } from 'react';

// const CompensationBeneficiaryUpdate = ({ beneficiaryDetails, onUpdate, initialLandShare, initialCompensationAmount }) => {
//   // Function to handle changes in LandShare and CompensationAmount
//   const handleChange = (index, field, value) => {
//     const updatedDetails = [...beneficiaryDetails];
//     updatedDetails[index][field] = value;

//     // When LandShare is updated, calculate the new CompensationAmount
//     if (field === "LandShare") {
//       updatedDetails[index].CompensationAmount = calculateCompensationAmount(value);
//     }

//     onUpdate(updatedDetails); // Notify parent component of the updated details
//   };

//   // Calculate Compensation Amount based on LandShare
//   const calculateCompensationAmount = (landShare) => {
//     const baseCompensation = initialCompensationAmount; // This can be a fixed value or dynamic based on your logic
//     return (baseCompensation * landShare) / 100; // Adjust the formula as per your business logic
//   };

//   useEffect(() => {
//     // Set initial CompensationAmount when the component mounts
//     const updatedDetails = beneficiaryDetails.map((beneficiary) => ({
//       ...beneficiary,
//       CompensationAmount: calculateCompensationAmount(initialLandShare),
//     }));
//     onUpdate(updatedDetails); // Update parent with new CompensationAmount
//   }, [initialLandShare, initialCompensationAmount, beneficiaryDetails, onUpdate]);

//   return (
//     <div className="flex-1 px-6 py-4 overflow-auto">
//       <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
//         <h1>Compensation Share B/w Beneficiary</h1>
//       </div>

//       <h2 className="text-[#241C68] underline mb-4"> &#x25CF; Consent</h2>
//       <span className="text-red-600">Please Upload Common Consent Letter in Order to change Compensation Share</span>

//       <section className="mt-6">
//         <div className="items-center justify-center grid grid-cols-4">
//           <label
//             htmlFor="dropzone-file"
//             className="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-200"
//           >
//             <div className="flex items-center justify-end pt-5 pb-6">
//               <p className="text-xs text-gray-500 dark:text-gray-400 mr-2">
//                 📄 Common Consent
//               </p>
//               <svg
//                 className="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
//                 aria-hidden="true"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 20 16"
//               >
//                 <path
//                   stroke="currentColor"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
//                 />
//               </svg>
//             </div>
//             <input id="dropzone-file" type="file" className="hidden" />
//           </label>
//         </div>
//       </section>

//       <section className="mt-10">
//         <table className="w-full border-collapse border border-gray-300">
//           <thead>
//             <tr className="bg-gray-100">
//               <th className="border border-gray-300 p-2">Beneficiary</th>
//               <th className="border border-gray-300 p-2">Land Share %</th>
//               <th className="border border-gray-300 p-2">Compensation Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {beneficiaryDetails.map((beneficiary, index) => (
//               <tr key={beneficiary.BeneficiaryId}>
//                 <td className="border border-gray-300 p-2">
//                   <input
//                     className="w-full"
//                     type="text"
//                     value={beneficiary.Name || ""}
//                     readOnly
//                     onChange={(e) => handleChange(index, "Name", e.target.value)}
//                   />
//                 </td>
//                 <td className="border border-gray-300 p-2">
//                   <input
//                     className="w-full"
//                     type="text"
//                     value={beneficiary.LandShare || ""}
//                     onChange={(e) => handleChange(index, "LandShare", e.target.value)}
//                   />
//                 </td>
//                 <td className="border border-gray-300 p-2">
//                   <input
//                     className="w-full"
//                     type="text"
//                     readOnly
//                     value={beneficiary.CompensationAmount || ""}
//                     onChange={(e) =>
//                       handleChange(index, "CompensationAmount", e.target.value)
//                     }
//                   />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </section>

//       <button className="border bg-[#241C68] text-white w-full mt-3.5">Save</button>
//     </div>
//   );
// };

// export default CompensationBeneficiaryUpdate;



// import React, { useEffect } from 'react';

// const CompensationBeneficiaryUpdate = ({ beneficiaryDetails, onUpdate, initialLandShare, initialCompensationAmount }) => {
//   // Function to handle changes in LandShare and CompensationAmount
//   const handleChange = (index, field, value) => {
//     const updatedDetails = [...beneficiaryDetails];
//     updatedDetails[index][field] = value;

//     // When LandShare is updated, calculate the new CompensationAmount
//     if (field === "LandShare") {
//       updatedDetails[index].CompensationAmount = calculateCompensationAmount(value);
//     }

//     onUpdate(updatedDetails); // Notify parent component of the updated details
//   };

//   // Calculate Compensation Amount based on LandShare
//   const calculateCompensationAmount = (landShare) => {
//     const baseCompensation = initialCompensationAmount; // This can be a fixed value or dynamic based on your logic
//     return (baseCompensation * landShare) / 100; // Adjust the formula as per your business logic
//   };

//   useEffect(() => {
//     // Set initial CompensationAmount when the component mounts
//     const updatedDetails = beneficiaryDetails.map((beneficiary) => ({
//       ...beneficiary,
//       CompensationAmount: calculateCompensationAmount(beneficiary.LandShare), // Use individual LandShare for each beneficiary
//     }));
//     onUpdate(updatedDetails); // Update parent with new CompensationAmount
//   }, [beneficiaryDetails, initialLandShare, initialCompensationAmount, onUpdate]); // Added dependencies for proper re-renders

//   return (
//     <div className="flex-1 px-6 py-4 overflow-auto">
//       <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
//         <h1>Compensation Share B/w Beneficiary</h1>
//       </div>

//       <h2 className="text-[#241C68] underline mb-4"> &#x25CF; Consent</h2>
//       <span className="text-red-600">Please Upload Common Consent Letter in Order to change Compensation Share</span>

//       <section className="mt-6">
//         <div className="items-center justify-center grid grid-cols-4">
//           <label
//             htmlFor="dropzone-file"
//             className="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-200"
//           >
//             <div className="flex items-center justify-end pt-5 pb-6">
//               <p className="text-xs text-gray-500 dark:text-gray-400 mr-2">
//                 📄 Common Consent
//               </p>
//               <svg
//                 className="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
//                 aria-hidden="true"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 20 16"
//               >
//                 <path
//                   stroke="currentColor"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
//                 />
//               </svg>
//             </div>
//             <input id="dropzone-file" type="file" className="hidden" />
//           </label>
//         </div>
//       </section>

//       <section className="mt-10">
//         <table className="w-full border-collapse border border-gray-300">
//           <thead>
//             <tr className="bg-gray-100">
//               <th className="border border-gray-300 p-2">Beneficiary</th>
//               <th className="border border-gray-300 p-2">Land Share %</th>
//               <th className="border border-gray-300 p-2">Compensation Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {beneficiaryDetails.map((beneficiary, index) => (
//               <tr key={beneficiary.BeneficiaryId}>
//                 <td className="border border-gray-300 p-2">
//                   <input
//                     className="w-full"
//                     type="text"
//                     value={beneficiary.Name || ""}
//                     readOnly
//                     // The Name field is now read-only, so no need to handle changes for it
//                   />
//                 </td>
//                 <td className="border border-gray-300 p-2">
//                   <input
//                     className="w-full"
//                     type="text"
//                     value={beneficiary.LandShare || ""}
//                     onChange={(e) =>
//                       handleChange(index, "LandShare", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td className="border border-gray-300 p-2">
//                   <input
//                     className="w-full"
//                     type="text"
//                     readOnly
//                     value={beneficiary.CompensationAmount || ""}
//                     // The CompensationAmount field is read-only since it's calculated automatically
//                   />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </section>

//       <button className="border bg-[#241C68] text-white w-full mt-3.5">Save</button>
//     </div>
//   );
// };

// export default CompensationBeneficiaryUpdate;
